import { useRef, useEffect, useState } from 'react'
import { useClickOutside } from '@react-hookz/web'
import { Icon, Text } from '@monolithmtl/components'
import { Label } from 'theme-ui'
import { snakeCase } from 'lodash'

const Select = ({
  name,
  options,
  handle,
  defaultValue = null,
  sx,
  onChange = () => {},
  handler = () => {},
  icon,
  uuid,
  ...props
}) => {
  const ref = useRef(null)
  const id = handle || snakeCase(name)

  const [open, setOpen] = useState(null)
  const [selected, setSelected] = useState(defaultValue)

  const onOptionSelect = (value, native) => {
    if (!native) setOpen(false)
    setSelected(value)
    onChange()
  }

  // Hack for Netlify
  useEffect(() => {
    handler({
      target: {
        name: id,
        value: selected,
      },
    })
  }, [selected, id])

  useEffect(() => setSelected(defaultValue), [defaultValue])

  useClickOutside(ref, () => setOpen(false))

  return (
    <div sx={{ variant: 'forms.select', ...sx }} aria-expanded={open} data-value={!!selected || false}>
      <aside onClick={() => setOpen((prev) => !prev)}>
        <select
          id={id}
          name={id}
          value={selected || ''}
          onChange={(event) => onOptionSelect(options[event.target.options.selectedIndex - 1], true)}
          {...props}
        >
          <option hidden disabled value="" />
          {options.map((option, i) => (
            <option key={(uuid || option) + i} value={option} children={option} />
          ))}
        </select>
        <Label htmlFor={id} children={name} />
        {icon && <Icon icon={icon} sx={{ '--stroke-absolute': 'var(--stroke-absolute-value)', p: '1px' }} />}
      </aside>

      <ul ref={ref} sx={{ variant: 'forms.select.dropdown' }} aria-hidden={!open}>
        {options.map((option, i) => (
          <li
            key={'custom' + (uuid || option) + i}
            data-selected={!!(option === selected) ? true : null}
            onClick={() => onOptionSelect(option, false)}
          >
            {option}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Select
